<template>
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23 0a1 1 0 0 1 1 1v20.003A3.007 3.007 0 0 1 21 24H3h-.003a3.007 3.007 0 0 1-2.991-2.824L0 21v-8a1 1 0 0 1 .883-.993L1 12h1a1 1 0 0 1 .117 1.993L2 14v6.997c.002.514.388.937.886.996L3 22l.114-.007c.46-.055.824-.42.879-.877L4 21V1a1 1 0 0 1 1-1zm-1 2H6v19.003c-.001.35-.062.685-.172.997h15.169A1.005 1.005 0 0 0 22 21V2zm-3 15a1 1 0 0 1 .117 1.993L19 19H9a1 1 0 0 1-.117-1.993L9 17h10zm0-4a1 1 0 0 1 .117 1.993L19 15H9a1 1 0 0 1-.117-1.993L9 13h10zm0-8a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h10zm-1 2h-8v2h8V7z"
      fill="currentColor"
      fill-rule="nonzero"
    />
  </svg>
</template>
